import { useAsyncAction } from "legacy-components/form/action/AsyncAction";
import ApplicationService from "pages/home/applications/components/v2.0/ApplicationService";
import { useMemo } from "react";

export const useResourceAppVersionProvider = (resourceAppId : string) => {

    const [state, { subscribe }] = useAsyncAction(() => ApplicationService.getAllVersions(resourceAppId));

    return useMemo(() => ({ versionState: state, getVersions: subscribe }), [state, subscribe]);   

}